module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', [_vm._v("VUX V2.1.1Rc.8 发布日志")]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/popup-picker.html"
    }
  }, [_vm._v("PopupPicker")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[enhance] 更新头部样式并新增 less 变量")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/tabbar.html"
    }
  }, [_vm._v("Tabbar")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持点击时切换图标")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-header.html"
    }
  }, [_vm._v("XHeader")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[fix] 修复过渡动画")]), _vm._v(" "), _c('li', [_vm._v("[fix] 修复 返回文字 国际化")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-input.html"
    }
  }, [_vm._v("XInput")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持设置 placeholder 对齐方式")])]), _vm._v(" "), _c('h2', [_c('a', {
    attrs: {
      "href": "/zh-CN/components/x-textarea.html"
    }
  }, [_vm._v("XTextarea")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("[feature] 支持title属性")])])])
}]}
module.exports.render._withStripped = true
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
     require("vue-hot-reload-api").rerender("data-v-79292f16", module.exports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/ream/~/vue-loader/lib/template-compiler?{"id":"data-v-79292f16"}!./~/ream/~/vue-loader/lib/selector.js?type=template&index=0!./~/v-markdown-loader/_cache/v2.1.1-rc.8-214.vue
// module id = 2354
// module chunks = 337